import React from 'react'
import SortInput from '@components/SortInput'
import { SortFieldProps } from './interface'

const SortField = ({
  label,
  classNameSelect,
  className,
  ...props
}: SortFieldProps) => {
  return (
    <div className={className}>
      {label && (
        <div className='font-light text-[12px] mb-[5px] text-secondary-1'>
          {label}
        </div>
      )}
      <SortInput className={classNameSelect} {...props} />
    </div>
  )
}

export default SortField
